module.exports =
  '_RANKING_GROUP':
    'LIST_TITLE': "Ranking of user"
    'JOINED_LIST': 'Group list'
    'PARTICIPANTS' : 'Participants'
    'NONPARTICIPANTS': 'Non-participation'
    'EVENT_RANK':
      'RANKING_NAME': 'Ranking'
      'AVG_SCORE': 'Average score'
      'AVG_PUTT': 'Average putt '
      'RAT_PAR_ON': 'Per on Rate （% Notation）'
      'RAT_BIRDIE': 'Birdie Rate （% Notation）'
      'RAT_PAR': 'Per Rate （% Notation）'
      'SCORE_DETAILS': 'Score details'
      'CLOSE': 'Close'
      'UNNAMED': 'Unnamed'
      'SCORE_ANALYSIS': 'Overall score analysis'



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-ranking/i18n/en.coffee